import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class TranslateStoreService {
  private readonly translate = inject(TranslateService);

  get getLanguage(): string {
    return this.translate.currentLang || this.translate.defaultLang || 'it';
  }

  instant(key: string): string {
    return this.translate.instant(key);
  }

  use(lang: string): void {
    void this.translate.use(lang);
  }
}
